import { useEffect, useState } from "react";
import {
  CompanyDeleteCompanyStore,
  CompanyFilterCompanyStore,
  CompanyChangeOrderCompanyStore,
} from "../../Api/Services";
import imgDelete from "../../assets/Icon/icons8-remove-100.png";
import imgIdentity from "../../assets/Icon/icons8-identity-64.png";
import imgDoc from "../../assets/Icon/icons8-edit-48.png";
import { confirmAlert } from "react-confirm-alert";
import imgPlus from "../../assets/Icon/pluse.png";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import icon4 from "../../assets/Icon/04.png";

function Store() {
  const [Data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();

  let { id } = useParams();

  const start = async () => {
    try {
      const CompanyFilterCompanyStoreData = await CompanyFilterCompanyStore({
        CompanyId: id,
      });
      if (
        CompanyFilterCompanyStoreData.status &&
        CompanyFilterCompanyStoreData.status === 200
      ) {
        setData(CompanyFilterCompanyStoreData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const confirmDelete = (e) => {
    confirmAlert({
      title: "حذف  انبار",
      message: "آیا مطمئن هستید ؟",
      buttons: [
        {
          label: "بله",
          onClick: () => DeleteItem(e),
        },
        {
          label: "خیر",
        },
      ],
    });
  };

  const DeleteItem = async (e) => {
    try {
      setLoading(true);
      const CompanyDeleteCompanyStoreData = await CompanyDeleteCompanyStore(e);
      if (
        CompanyDeleteCompanyStoreData.status &&
        CompanyDeleteCompanyStoreData.status === 200
      ) {
        toast.success("عملیات با موفقیت انجام شد");
        await start();
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const Add = () => {
    navigate("/Panel/Companys/Store/Add/" + id);
  };

  const Edite = (extra) => {
    navigate(`/Panel/Companys/Store/Edite/${id}/${extra}`);
  };

  const Identity = (item) => {
    navigate(`/Panel/Companys/Store/Identity/${id}/${item}`);
  };

  const ShowStoreCompetitor = (item) => {
    navigate(`/Panel/Companys/Store/Competitor/${id}/${item}`);
  };

  const ChandeOrder = async (e) => {
    const newSearch = [...Data];
    newSearch.find((w) => w.id == e.target.id).order = e.target.value;
    setData(newSearch);
  };

  const FixChandeOrder = async (e) => {
    if (e.key == "Enter") {
      try {
        setLoading(true);
        const CompanyChangeOrderCompetitorData =
          await CompanyChangeOrderCompanyStore({
            id: e.target.id,
            order: e.target.value,
          });
        if (
          CompanyChangeOrderCompetitorData.status &&
          CompanyChangeOrderCompetitorData.status === 200
        ) {
          toast.success("عملیات با موفقیت انجام شد");
          await start();
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
      }
    }
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-start align-items-center w-100 mb-5 pointer">
            <img
              onClick={() => {
                Add();
              }}
              src={imgPlus}
              alt=""
            />
          </div>
          <div className="d-flex justify-content-center align-items-center w-100 p-2 tableC">
            <table className="table">
              <thead className="sticky-header">
                <tr className="trTable">
                  <th>الویت نمایش</th>
                  <th>نام</th>
                  <th>لیست قیمت اتوماتیک</th>
                  <th>نام لیست قیمت</th>
                  <th>کد</th>
                  <th>درصد</th>
                  <th>متصل به سایت</th>
                  <th>ادرس سایت</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {Data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <input
                        id={item.id}
                        className="w-25"
                        value={item.order}
                        onKeyUp={(e) => FixChandeOrder(e)}
                        onChange={(e) => ChandeOrder(e)}
                      />
                    </td>
                    <td>{item.name}</td>
                    <td>{item.isList ? "فعال" : "غیرفعال"}</td>
                    <td>
                      {item.isList &&
                        item.competitorCompetitorCategoryName +"-"+
                          item.competitorName}
                    </td>
                    <td>{item.code}</td>
                    <td>{item.percentage}</td>
                    <td>{item.isSite ? "متصل" : "-"}</td>
                    <td>{item.urlSite}</td>
                    <td className="td-actions">
                      <span
                        className="d-inline-block pointer ms-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="حذف"
                      >
                        <img
                          height="30"
                          className="me-2"
                          src={imgDelete}
                          alt="حذف"
                          onClick={() => {
                            confirmDelete(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="ویرایش"
                      >
                        <img
                          height="30"
                          src={imgDoc}
                          alt="ویرایش"
                          onClick={() => {
                            Edite(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer m-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="دسترسی"
                      >
                        <img
                          height="40"
                          src={imgIdentity}
                          alt="دسترسی"
                          onClick={() => {
                            Identity(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer m-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="مراجع"
                      >
                        <img
                          height="40"
                          src={icon4}
                          alt="مراجع"
                          onClick={() => {
                            ShowStoreCompetitor(item.id);
                          }}
                        />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Store;
